import React from 'react';
import { GroupButton } from '../common';
import { AddSquareIcon, ArrowDownIcon, DownloadIcon, FilterIcon, SearchIcon } from '../../assets/icons';
import AddSquare from '../../assets/icons/AddSquare';
import BinIcon from '../../assets/icons/BinIcon';
import ListInventoryBody from '../inventory/list/ListInventoryBody';
import { DropdownComponent } from '../core/Forms';
import { FILTER_LIST } from '../../constants';

const PurchaseTable = (props: any) => {
  const [data, setData] = React.useState<typeof props.data>([]);

  React.useEffect(() => {
    setData(props.data);
  }, [props.data]);

  const [selectedValue, setSelectedValue] = React.useState(' Recent');
  const dropDownArray = FILTER_LIST;
  const [isSubmitted, setIsSubmitted] = React.useState(false);
  const handleDropDownChange = (value: string) => {
    // handleSort ? handleSort(selectedValue) : null;
  };

  const tableHead = [
    { dataIndex: 'index', title: 'ID', className: 'text-center' },
    { dataIndex: 'name', title: 'Product Name' },
    { dataIndex: 'quantityRestocked', title: 'Qty Restocked' },
    { dataIndex: 'variation', title: 'Variation' },
    { dataIndex: 'date', title: 'Date' },
    { dataIndex: 'oldSellingPrice', title: 'Old Selling Price' },
    { dataIndex: 'newSellingPrice', title: 'New Selling Price' },
  ];

  return (
    <>
      <div className="flex items-center justify-between mt-16">
        <h2 className="font-semibold text-[20px]">Restock Details</h2>
        <div className="flex justify-between items-center">
          <DropdownComponent
            options={dropDownArray}
            value={selectedValue}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            isSubmitted={isSubmitted}
            onChange={handleDropDownChange}
            dropdownClassName="w-[140px] md:max-w-[200px] md:mt[0 lg:mt-0  xl:w-full md:mr-[0em] lg:w-[120px] xl:w-full lg:ml-[-7em] xl:ml-[-10em] lg:mt-0 xl:w-[300px] bg-white rounded xl:rounded xl:focus:ring-0 xl:pointer-events "
            iconClassName="xl:mt-[3px] mr-[1em] mt-[0em] md:mt-[0.3em] md:mr-[1.2em] md:mt-[0.5em] xl:mr-[4em]"
          />
        </div>
      </div>
      <ListInventoryBody showPagination={false} data={data} isLoading={props.isLoading} tableHead={tableHead} />
    </>
  );
};

export default PurchaseTable;
